
























































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import api from "@/getinfo-api";
import { Company as ICompany } from "@/api/models/company";
import { CompanyForm as ICompanyForm } from "@/api/models/company-form";
import { UsersList as IUsersList } from "@/api/models/users-list";
import EditorWithFile from "@/components/EditorWithFile.vue";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { currentUserIsCompanyOwner, isRoot } from "@/plugins/roles";
import { CommissionPerson as ICommissionPerson } from "@/api/models/commission-person";
import { CompanyDocumentInfoEdit as ICompanyDocumentInfoEdit } from "@/api/models/company-document-info-edit";
import { CompanyDocumentInfo as ICompanyDocumentInfo } from "@/api/models/company-document-info";
import CustomInput from "@/components/form/CustomInput.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {
  bookkeepingModule,
  learningDocumentsModule
} from "@/plugins/modules-detect";
import timeZones from "@/plugins/time-zones";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { EmployeeEdit as IEmployeeEdit } from "@/api/models/employee-edit";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CompanyNotificationForm from "@/components/notification/CompanyNotificationForm.vue";
import { Company, NotificationSettingsTypes } from "@/services/notifications";
import { CompanySettings as ICompanySettings } from "@/api-v2/notification/models/company-settings";
import { Tokens as ITokens } from "@/api-v2/notification/models/tokens";

@Component({
  components: {
    CompanyNotificationForm,
    CBlock,
    DeleteMaterialModal,
    CSingleSelect,
    CField,
    CustomButton,
    EditorWithFile,
    SelectEntity,
    CustomInput
  }
})
export default class CompanyPageForm extends Vue {
  @Prop() companyInfo?: ICompany;
  @Prop() notificationSettings?: {
    course: ICompanySettings;
    test: ICompanySettings;
    order: ICompanySettings;
  };
  showDeleteModal: boolean = false;
  users!: Array<IUsersList>;
  title!: string;
  owner!: string;
  description: string | undefined = "";
  enabled: boolean | undefined = true;
  processing: boolean = false;
  showNewOwner: boolean = !this.companyInfo;
  commission: Array<ICommissionPerson> = [];
  currentCommissionMember: ICommissionPerson = {};
  inn!: string | undefined;
  shortTitle!: string | undefined;
  legalAddress!: string | undefined;
  factAddress!: string | undefined;
  site!: string | undefined;
  kpp!: string | undefined;
  ogrn!: string | undefined;
  licenseList!: string | undefined;
  paymentAccount!: string | undefined;
  correspondentAccount!: string | undefined;
  bank!: string | undefined;
  bik!: string | undefined;
  okpo!: string | undefined;
  okato!: string | undefined;
  okved!: string | undefined;
  directorName!: string | undefined;
  directorNameGenitive!: string | undefined;
  directorPosition!: string | undefined;
  basis!: string | undefined;
  phones: Array<string> = [];
  emails: Array<string> = [];
  phone!: string;
  email!: string;
  isSavingProcess: boolean = false;
  timeZone: string | undefined = "Europe/Moscow";
  usersList: UsersListClass = new UsersListClass({});
  employeeList: EmployeesListClass | undefined = this.companyInfo
    ? new EmployeesListClass({ id: this.companyInfo?.id, limit: 70 })
    : undefined;
  notificationSettingsOrder?: ICompanySettings = {
    template: {
      body: "",
      header: "",
      footer: ""
    }
  };
  notificationSettingsTesting?: ICompanySettings = {
    template: {
      body: "",
      header: "",
      footer: ""
    }
  };
  notificationSettingsCourseEnrollment?: ICompanySettings = {
    template: {
      body: "",
      header: "",
      footer: ""
    }
  };
  notificationTokens?: ITokens;

  data() {
    return {
      notificationTokens: undefined,
      title: undefined,
      owner: undefined,
      users: undefined,
      inn: undefined,
      shortTitle: undefined,
      legalAddress: undefined,
      factAddress: undefined,
      site: undefined,
      kpp: undefined,
      ogrn: undefined,
      licenseList: undefined,
      paymentAccount: undefined,
      correspondentAccount: undefined,
      bank: undefined,
      bik: undefined,
      okpo: undefined,
      okato: undefined,
      okved: undefined,
      directorName: undefined,
      directorNameGenitive: undefined,
      directorPosition: undefined,
      basis: undefined,
      phone: undefined,
      email: undefined
    };
  }

  get root() {
    return isRoot();
  }

  get isCompanyOwner() {
    return currentUserIsCompanyOwner();
  }

  get zones() {
    return timeZones;
  }

  get isDocumentBundle() {
    return learningDocumentsModule() || bookkeepingModule();
  }

  get currentOwnerEmployee() {
    return this.employeeList?.employees?.find(
      el => el.user?.id === this.companyInfo?.owner?.id
    );
  }

  get notificationType() {
    return NotificationSettingsTypes;
  }

  addPhone() {
    if (this.phone) {
      this.phones.push(this.phone);
      this.phone = "";
    }
  }

  addEmail() {
    if (this.email) {
      this.emails.push(this.email);
      this.email = "";
    }
  }

  deletePhone(index: number) {
    this.phones.splice(index, 1);
  }

  deleteMail(index: number) {
    this.emails.splice(index, 1);
  }

  addCommissionMember() {
    if (
      this.currentCommissionMember.firstName &&
      this.currentCommissionMember.lastName &&
      this.currentCommissionMember.middleName
    ) {
      this.commission.push({
        firstName: this.currentCommissionMember.firstName,
        lastName: this.currentCommissionMember.lastName,
        middleName: this.currentCommissionMember.middleName,
        position: this.currentCommissionMember.position
      });
      this.currentCommissionMember.firstName = "";
      this.currentCommissionMember.lastName = "";
      this.currentCommissionMember.middleName = "";
      this.currentCommissionMember.position = "";
    } else {
      this.$bvToast.toast(
        `${this.$tc(this.$translate.OneOrMoreFieldsAreEmpty)}`,
        {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        }
      );
    }
  }

  removeCommissionMember(index: number) {
    this.commission.splice(index, 1);
  }

  getCommission() {
    if (this.companyInfo && this.companyInfo.id)
      api.CompanyApi.getDocumentInfo(this.companyInfo.id).then(
        (res: { data: ICompanyDocumentInfo }) => {
          res.data.commissionPersons
            ? (this.commission = res.data.commissionPersons)
            : null;
          this.inn = res.data.inn;
          this.shortTitle = res.data.shortTitle;
          this.legalAddress = res.data.legalAddress;
          this.factAddress = res.data.factAddress;
          this.site = res.data.site;
          this.kpp = res.data.kpp;
          this.ogrn = res.data.ogrn;
          this.licenseList = res.data.licensesList;
          this.paymentAccount = res.data.paymentAccount;
          this.correspondentAccount = res.data.correspondentAccount;
          this.bank = res.data.bank;
          this.bik = res.data.bik;
          this.okpo = res.data.okpo;
          this.okato = res.data.okato;
          this.okved = res.data.okved;
          this.directorName = res.data.directorName;
          this.directorNameGenitive = res.data.directorNameGenitive;
          this.directorPosition = res.data.directorPosition;
          this.basis = res.data.basis;
          res.data.phones && res.data.phones.length
            ? (this.phones = res.data.phones)
            : null;
          res.data.emails && res.data.emails.length
            ? (this.emails = res.data.emails)
            : null;
        }
      );
  }

  saveCommission() {
    if (this.companyInfo?.id) {
      let params: ICompanyDocumentInfoEdit = {
        commissionPersons: this.commission,
        shortTitle: this.shortTitle,
        inn: this.inn,
        legalAddress: this.legalAddress,
        factAddress: this.factAddress,
        licensesList: this.licenseList,
        site: this.site,
        kpp: this.kpp,
        ogrn: this.ogrn,
        paymentAccount: this.paymentAccount,
        correspondentAccount: this.correspondentAccount,
        bank: this.bank,
        bik: this.bik,
        okpo: this.okpo,
        okato: this.okato,
        okved: this.okved,
        directorName: this.directorName,
        directorNameGenitive: this.directorNameGenitive,
        directorPosition: this.directorPosition,
        basis: this.basis,
        phones: this.phone ? [this.phone, ...this.phones] : this.phones,
        emails: this.email ? [this.email, ...this.emails] : this.emails
      };
      api.CompanyApi.editDocumentInfo(this.companyInfo.id, params).catch(
        (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        }
      );
    }
  }

  createCompany() {
    this.isSavingProcess = true;
    const companyInfo: ICompanyForm = {
      title: this.title,
      owner: this.owner,
      description: this.description,
      timeZone: this.timeZone
    };
    api.CompanyApi.create(companyInfo)
      .then((res: { data: ICompany }) => {
        let newCompanyId: string;
        newCompanyId = res.data.id ? res.data.id : "";
        this.$router.push({
          name: "companyPage",
          params: { id: newCompanyId }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSavingProcess = false;
      });
  }

  async removeRoles() {
    const ownerIsContentManager = this.currentOwnerEmployee?.roles?.includes(
      "content_manager"
    );
    const deletedRoles = this.currentOwnerEmployee?.roles?.filter(
      role => role !== "content_manager"
    );

    try {
      const body: IEmployeeEdit = {
        removeRoles: deletedRoles,
        roles: ownerIsContentManager ? undefined : ["content_manager"]
      };
      if (this.companyInfo && this.currentOwnerEmployee) {
        await api.EmployeeApi.edit(
          this.companyInfo.id,
          this.currentOwnerEmployee?.id,
          body
        );
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }

  async editCompany() {
    if (this.companyInfo?.id) {
      this.isSavingProcess = true;
      this.isDocumentBundle ? this.saveCommission() : null;
      const companyInfo: ICompanyForm = {
        title: this.title,
        owner:
          this.owner !== this.companyInfo.owner.id
            ? this.owner
            : this.companyInfo.owner.id,
        description: this.description,
        timeZone: this.timeZone
      };

      await Company.setStudentStartLearningSettings(
        this.companyInfo.id!,
        this.notificationSettingsCourseEnrollment!
      );
      await Company.setStudentFinishLearning(
        this.companyInfo.id!,
        this.notificationSettingsTesting!
      );
      await Company.setNewLearningRequest(
        this.companyInfo.id!,
        this.notificationSettingsOrder!
      );

      api.CompanyApi.edit(this.companyInfo.id, companyInfo)
        .then(async (res: { data: ICompany }) => {
          if (
            this.enabled &&
            this.companyInfo &&
            this.enabled !== this.companyInfo.enabled
          ) {
            if (this.companyInfo?.id)
              api.CompanyApi.enable(this.companyInfo.id);
          } else if (
            this.companyInfo &&
            !this.enabled &&
            this.enabled !== this.companyInfo.enabled
          ) {
            if (this.companyInfo?.id)
              api.CompanyApi.disable(this.companyInfo.id);
          }
          if (res.data.id) {
            const isChangedOwner =
              this.companyInfo?.owner?.id === res.data?.owner?.id;

            if (!isChangedOwner) {
              await this.removeRoles();
            }
            await this.$router.push({
              name: "companyPage",
              params: { id: res.data.id }
            });
          }
        })
        .finally(() => {
          this.isSavingProcess = false;
        });
    }
  }

  hideDeleteModal() {
    this.showDeleteModal = false;
  }

  deleteCompany() {
    if (this.companyInfo) {
      api.CompanyApi._delete(this.companyInfo.id)
        .then(() => {
          this.$router.push({ name: "companies" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  setNotificationSettings() {
    this.notificationSettingsCourseEnrollment = this.notificationSettings?.course;
    this.notificationSettingsOrder = this.notificationSettings?.order;
    this.notificationSettingsTesting = this.notificationSettings?.test;
  }

  @Watch("notificationSettings", { deep: true, immediate: true })
  updateNotificationSettings() {
    this.setNotificationSettings();
  }

  async getNotificationTokens() {
    try {
      this.notificationTokens = await Company.getTokens(this.companyInfo?.id!);
    } catch (e) {
      throw new Error(e);
    }
  }

  mounted() {
    if (this.companyInfo) {
      this.getNotificationTokens();
      this.getCommission();
      this.title = this.companyInfo.title;
      this.description = this.companyInfo.description;
      this.enabled = this.companyInfo.enabled;
      this.owner = this.companyInfo.owner.id;
      this.timeZone = this.companyInfo?.timeZone
        ? this.companyInfo?.timeZone
        : "Europe/Moscow";
    } else {
      const allTimeZones = this.zones?.map(el => el.timezone);
      const localeTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (allTimeZones?.includes(localeTZ)) {
        this.timeZone = localeTZ;
      } else {
        this.timeZone = "Europe/Moscow";
      }
    }
  }
}
